import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { Link } from 'react-router-dom';


function TasksCompleteReportForm() {
  const [startDate, setStartDate] = useState('2024-08-01');
  const [endDate, setEndDate] = useState('2024-08-31');
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [format, setFormat] = useState('');

  const taskOptions = [
    { value: 'all', label: 'All' },
    { value: '29', label: 'ADDING ACRYLIC TEETH TO THE MODEL' },
    { value: '85', label: 'CHROME WAXUP' },
    { value: '27', label: 'EMAIL DIGITAL DATA TO THE DENTIST' },
    // ... Add all other options similarly
  ];

  const handleTaskChange = (selectedOptions) => {
    setSelectedTasks(selectedOptions);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'startDate':
        setStartDate(value);
        break;
      case 'endDate':
        setEndDate(value);
        break;
      case 'format':
        setFormat(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here if needed
  };

  return (
    <div className=" mt-5">
      <h2 className="text-left mb-4" style={{ color: '#343a40' }}>Parameters</h2>
      <Form
        onSubmit={handleSubmit}
        className="p-4 border rounded shadow-sm"
        style={{
          borderTop: '5px solid #007bff',
          maxWidth: '700px', // Adjust the width of the modal
          maxHeight: '500px', // Adjust the height of the modal
          overflowY: 'auto',  // Enable vertical scrolling if content exceeds height
        }}
      >
        <Form.Group as={Row} controlId="tasks-complete-start-date">
          <Form.Label column md={4} className="font-weight-bold">Start Date <span className="text-danger">*</span></Form.Label>
          <Col md={8}>
            <Form.Control
              type="date"
              name="startDate"
              value={startDate}
              onChange={handleInputChange}
              required
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="tasks-complete-end-date">
          <Form.Label column md={4} className="font-weight-bold">End Date <span className="text-danger">*</span></Form.Label>
          <Col md={8}>
            <Form.Control
              type="date"
              name="endDate"
              value={endDate}
              onChange={handleInputChange}
              required
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="tasks-complete-task">
          <Form.Label column md={4} className="font-weight-bold">Task</Form.Label>
          <Col md={8}>
            <InputGroup>
              <Select
                isMulti
                name="tasks"
                options={taskOptions}
                value={selectedTasks}
                onChange={handleTaskChange}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select tasks..."
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderColor: '#ced4da',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#007bff',
                    },
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: '#e9ecef',
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: '#495057',
                  }),
                }}
              />
            </InputGroup>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="tasks-complete-format">
          <Form.Label column md={4} className="font-weight-bold">Format <span className="text-danger">*</span></Form.Label>
          <Col md={8}>
            <Form.Control
              as="select"
              name="format"
              value={format}
              onChange={handleInputChange}
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
              <option value="json">JSON</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Col sm={{ span: 8, offset: 4 }}>
            <Link to="/Addcompletetask">
              <Button
                id="pay-per-task-submit"
                type="button"
                variant="primary"
                className="w-100 mt-2"
                style={{
                  backgroundColor: '#004aad',
                  borderColor: '#004aad',
                  marginTop: '10px',
                }}
              >
                Run
              </Button>
            </Link>
          </Col>
        </Form.Group>
      </Form>
      
    </div>
  );
}

export default TasksCompleteReportForm;
